<!-- 升级规则设置（由 behavior_level 的等级规则表单复制而来，独立维护） -->
<template>
  <div class="upgrade_rules">
    <el-form :model="form" ref="form" label-width="160px">
      <el-form-item label="启用等级升级规则：">
        <!-- <el-switch v-model="isStart" @change="isChangeSwitch"> </el-switch> -->
        <el-switch v-model="form.upIsOpen" :active-value="1" :inactive-value="0"> </el-switch>
      </el-form-item>
      <el-form-item label="等级有效期：">
        <el-radio-group
          v-model="form.upTimeType"
          class="valid-date"
          @change="changeGradeValidDate"
        >
          <el-radio :label="3">永久有效</el-radio>
          <el-radio :label="4">等级有效期至</el-radio>
          <span class="valid-inline">
            <el-input
              v-model="form.gradeValidNum"
              class="valid-num"
              placeholder="请输入内容"
              @focus="form.upTimeType = 4"
              @input="handleGradeValidNumInput"
              @blur="handleGradeValidNumBlur"
            ></el-input>
            <el-select
              v-model="form.gradeValidUnit"
              class="valid-unit"
              placeholder="请选择"
              @focus="form.upTimeType = 4"
            >
              <el-option label="年" value="year"></el-option>
              <el-option label="月" value="month"></el-option>
              <el-option label="日" value="day"></el-option>
            </el-select>
            <span class="valid-text">后失效</span>
          </span>
          <el-radio :label="2">等级有效期至</el-radio>
          <span class="valid-inline">
            <el-input
              v-model="form.gradeValidYearNum"
              class="valid-num"
              placeholder="请输入内容"
              @focus="form.upTimeType = 2"
              @input="handleGradeValidYearNumInput"
              @blur="handleGradeValidYearNumBlur"
            ></el-input>
            <span class="valid-text">年后的</span>
            <el-select
              v-model="form.gradeValidMonth"
              class="valid-unit"
              placeholder="请选择"
              @focus="form.upTimeType = 2"
              @change="handleGradeValidMonthChange"
            >
              <el-option
                v-for="m in monthOptions"
                :key="m"
                :label="m"
                :value="m"
              ></el-option>
            </el-select>
            <span class="valid-text">月</span>
            <el-select
              v-model="form.gradeValidDay"
              class="valid-unit"
              placeholder="请选择"
              @focus="form.upTimeType = 2"
            >
              <el-option
                v-for="d in dayOptions"
                :key="d"
                :label="d"
                :value="d"
              ></el-option>
            </el-select>
            <span class="valid-text">日失效</span>
          </span>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="数据有效范围：">
        <span style="margin-right: 8px">从</span>
        <el-date-picker
          v-model="form.upOrderValidDate"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <span style="margin-left: 8px">开始累计订单</span>
      </el-form-item>
      <el-form-item label="等级设置：">
        <!-- 表格 -->
        <y-table
          :tableInfo="tableInfo"
          :tableData="form.gradeDetailList"
          :autoMaxHeight="false"
        >
          <template #gradeName="scope">
            <div class="tableCont">{{ scope.row.gradeName }}</div>
          </template>

          <template #gradeRule="scope">
            <div v-if="scope.rowIndex == 0" class="tableCont">
              最低等级，无需设置升级规则
            </div>
            <div class="rule-list" v-else>
              <div
                class="rule-line"
                v-for="(rule, ruleIndex) in scope.row.upgradeRules || []"
                :key="'rule' + ruleIndex"
              >
                <span class="rule-text">{{ formatRule(rule) }}</span>
                <div>
                  <span
                    class="rule-opt"
                    @click="handleEditRule(scope.row, ruleIndex)"
                    >编辑</span
                  >
                  <span
                    class="rule-opt"
                    @click="handleRemove(scope.row, ruleIndex)"
                    >删除</span
                  >
                </div>
              </div>
              <div
                class="rule-add"
                v-if="(scope.row.upgradeRules || []).length < 3"
              >
                <y-button type="blueText" @click="handleAdd(scope.row)"
                  >+新建规则</y-button
                >
              </div>
            </div>
          </template>
          <template #trade="scope">
            <div v-if="scope.rowIndex == 0" class="tableCont">
              最低等级，无需设置升级规则
            </div>
            <div style="justify-content: flex-start" v-else>
              <div class="tableCont">
                <div>
                  订单指标：累计交易次数满:
                  <el-input
                    v-model="scope.row.upgradeMinCount"
                    v-numZOnly
                    class="inline_input"
                    placeholder="请输入"
                  ></el-input>
                  次
                </div>
              </div>
            </div>
          </template>
        </y-table>
      </el-form-item>
    </el-form>
    <y-dialog
      title="移除黑名单"
      :visible.sync="removeVisible"
      width="580px"
      :draggable="false"
      @close="removeVisible = false"
    >
      <div class="remove-tip">
        删除后规则将失效，原按规则进行等级变更的会员不受影响，确认删除?
      </div>
      <template slot="footer">
        <y-button @click="removeVisible = false">取消</y-button>
        <y-button type="blue" @click="confirmRemove">确定</y-button>
      </template>
    </y-dialog>
    <!-- 选择商品组件 -->
    <select-goods
      v-if="goodsState"
      @transferName="goodsPopupBtn"
      :postForm="goodsPostForm"
      :skuIsShow="false"
      :scoresCardId="$store.state.MemberSystemInfo.scoresCardId"
    ></select-goods>
    <!-- 新建升级规则 -->
    <upgradeRulesDialog
      v-if="upgradeRulesVisible"
      title="升级规则"
      :visible.sync="upgradeRulesVisible"
      :row="upgradeRuleRow"
      :rule-index="upgradeRuleIndex"
      :rule="upgradeRuleData"
      :grade-list="form.gradeDetailList"
      @close="upgradeRulesVisible = false"
      @save="saveUpgradeRule"
    ></upgradeRulesDialog>
  </div>
</template>

<script>
import { upRuleSwitch, ruleSave } from "@/api/manage/scoreList";
import selectGoods from "@/components/select-goods.vue";
import upgradeRulesDialog from "./components/upgradeRulesDialog.vue";
export default {
  components: {
    selectGoods,
    upgradeRulesDialog,
  },
  props: {
    upRuleType: {
      default: "",
    },
  },
  data() {
    return {
      isStart: false, //是否启用规则
      _upRuleType: "",
      form: {
        upIsOpen: 1, // 是否启用升级规则
        upOrderValidDate: "",
        behaviorLevelCalcRule: 0,
        gradeDetailList: [],
        upTimeType: 3,
        gradeValidNum: "", // 方式2的数值：1-999 的正整数
        gradeValidUnit: "year", // year / month / day
        gradeValidYearNum: "", // 方式3的数值：1-999 的正整数
        gradeValidMonth: "", // 方式3的月份
        gradeValidDay: "", // 方式3的日期
        gradeUpgradeRule: 1, // 保级不成功设置（随表单一起提交）
      },
      // 方式3：月 / 日 下拉选项（日期部分见 computed.dayOptions，随月份变化）
      monthOptions: Array.from({ length: 12 }, (v, i) => i + 1),
      loading: false,
      goodsState: false, // 选择商品弹窗
      goodsPostForm: [], // 已选商品数据---弹窗用
      selectGoodsList: [], // 已选商品列表--指定商品
      selectGoodsList2: [], // 已选商品列表--排除特定商品
      selectGoodsType: 1, // 用于储存当前打开的弹窗类型，因公用一个组件，以此区分
      selectGoodsIndex: 1, // 用于储存当前选择商品的下标
      // 新建升级规则弹窗
      upgradeRulesVisible: false,
      upgradeRuleRow: {},
      upgradeRuleIndex: null, // null 新建，数字为编辑下标
      upgradeRuleData: null, // 编辑时回显的规则
      tableInfo: [
        {
          label: "等级名称",
          prop: "gradeName",
          slot: "gradeName",
          align: "center",
          width: "400px",
        },
        {
          label: "等级规则（或关系）",
          align: "center",
          prop: "gradeName",
          slot: "gradeRule",
        },
      ],
      removeVisible: false, // 移除黑名单弹窗
      removeRow: {}, // 移除黑名单弹窗数据
      removeIndex: 0, // 移除黑名单弹窗下标
    };
  },
  created() {
    // 获取当前会员体系详情
    this.MemberSystemInfo = this.$store.state.MemberSystemInfo;
  },
  mounted() {
    // 详情数据由父级（behavior_level）统一请求后通过 initDetail 传入
    //判断开启状态
    this._upRuleType = this.upRuleType;
    if (this._upRuleType == 1) {
      this.isStart = true;
    }
  },
  computed: {
    // 方式3的日期选项：2 月只有 1-28，其余月份 1-31
    dayOptions() {
      const max = Number(this.form.gradeValidMonth) === 2 ? 28 : 31;
      return Array.from({ length: max }, (v, i) => i + 1);
    },
  },
  methods: {
    changeGradeValidDate(val) {
      // 切到「数值+单位」时，单位没选过就给个默认值
      if (val === 2 && !this.form.gradeValidUnit) {
        this.form.gradeValidUnit = "year";
      }
    },
    // 等级有效期数值：只允许正整数，最大 999
    normalizeGradeValidNum(val) {
      let num = String(val === null || val === undefined ? "" : val).replace(
        /\D/g,
        ""
      );
      if (num && Number(num) > 999) {
        num = "999";
      }
      return num;
    },
    // 失焦时兜底最小值
    fixGradeValidNum(num) {
      if (num === "" || num === null || num === undefined) return "";
      return Number(num) < 1 ? "1" : String(num);
    },
    // 方式2：N 年/月/日 后失效
    handleGradeValidNumInput(val) {
      this.form.gradeValidNum = this.normalizeGradeValidNum(val);
    },
    handleGradeValidNumBlur() {
      this.form.gradeValidNum = this.fixGradeValidNum(this.form.gradeValidNum);
    },
    // 方式3：月份变化后，已选日期超出当月天数则清空，避免出现「2月31日」
    handleGradeValidMonthChange(val) {
      this.form.upTimeType = 2;
      const max = Number(val) === 2 ? 28 : 31;
      if (this.form.gradeValidDay && Number(this.form.gradeValidDay) > max) {
        this.form.gradeValidDay = "";
      }
    },
    // 方式3：N 年后的指定时间失效（独立字段，互不影响）
    handleGradeValidYearNumInput(val) {
      this.form.gradeValidYearNum = this.normalizeGradeValidNum(val);
    },
    handleGradeValidYearNumBlur() {
      this.form.gradeValidYearNum = this.fixGradeValidNum(
        this.form.gradeValidYearNum
      );
    },
    // 点击「移除」：打开二次确认弹窗
    handleRemove(row, index) {
      this.removeRow = row || {};
      this.removeIndex = index || 0;
      this.removeVisible = true;
    },
    // 回显：详情数据由父级统一请求后传入，本组件不再单独调接口
    initDetail(data) {
      if (!data) return;
      const res = { data };
      // 接口未返回等级有效期相关字段时，用默认值兜底
        this.form = Object.assign(
          {
            upIsOpen: 1, // 是否启用升级规则
            upTimeType: 3,
            gradeValidNum: "",
            gradeValidUnit: "year",
            gradeValidYearNum: "",
            gradeValidMonth: "",
            gradeValidDay: "",
          },
          res.data
        );
        if (!this.form.upTimeType) {
          this.form.upTimeType = 3;
        }
        if (!this.form.gradeValidUnit) {
          this.form.gradeValidUnit = "year";
        }
        (this.form.gradeDetailList || []).forEach((item) => {
          item.specificItems = [];
          item.excludeItems = [];
          // 升级规则：后端未返回时初始化为空数组，保证表格可渲染
          if (!item.upgradeRules) {
            this.$set(item, "upgradeRules", []);
          }
          if (
            item.itemSelectType == 1 &&
            item.gradeItems &&
            item.gradeItems.length > 0
          ) {
            item.gradeItems.forEach((goods) => {
              item.specificItems.push({
                itemTitle: goods.itemName,
                price: goods.itemPrice,
                picUrl: goods.itemImage,
                numIid: goods.itemSkuId,
                channelSellerManageId: goods.channelSellerManageId,
                platform: goods.platform,
              });
            });
          } else if (
            item.itemSelectType == 2 &&
            item.gradeItems &&
            item.gradeItems.length > 0
          ) {
            item.gradeItems.forEach((goods) => {
              item.excludeItems.push({
                itemTitle: goods.itemName,
                price: goods.itemPrice,
                picUrl: goods.itemImage,
                numIid: goods.itemSkuId,
                channelSellerManageId: goods.channelSellerManageId,
                platform: goods.platform,
              });
            });
          } else {
            item.specificItems = [];
            item.excludeItems = [];
          }
        });
      this.changeBehaviorLevelCalcRule(res.data.behaviorLevelCalcRule);
    },
    // 校验（父级点保存时统一调用，校验不通过自行提示）
    validate() {
      if (!this.form.upOrderValidDate) {
        this.$message.warning("【升级规则】请选择数据有效范围!");
        return false;
      }
      // 每个等级都要至少配置一条升级规则
      const gradeList = this.form.gradeDetailList || [];
      for (let i = 1; i < gradeList.length; i++) {
        const rules = (gradeList[i].upgradeRules || []).filter(Boolean);
        if (!rules.length) {
          this.$message.warning(
            "【升级规则】请为" + gradeList[i].gradeName + "等级配置升级规则!"
          );
          return false;
        }
      }
      return true;
    },
    // 保存
    save() {
      if (!this.validate()) return;
      //根据接口进行处理
      this.form.scoresCardId = this.MemberSystemInfo.scoresCardId;
      let _from = JSON.parse(JSON.stringify(this.form));
      _from.gradeDetailList.forEach((item) => {
        item.gradeItems = [];
        const source =
          item.itemSelectType == 1 ? item.specificItems : item.excludeItems;
        if (item.itemSelectType != 0 && source && source.length > 0) {
          source.forEach((goods) => {
            item.gradeItems.push({
              itemName: goods.itemTitle,
              itemPrice: goods.price,
              itemImage: goods.picUrl,
              itemSkuId: goods.numIid,
              channelSellerManageId: goods.channelSellerManageId,
              platform: goods.platform,
            });
          });
        }
        delete item.specificItems;
        delete item.excludeItems;
      });
      // 保存接口就绪后打开下面的请求
      // ruleSave(_from).then((res) => {
      //   if (res.code == 200) {
      //     this.$message.success("保存成功");
      //   } else {
      //     this.$message.error(res.message);
      //   }
      // });
      // 返回组装好的 form 数据，由父级统一合并提交
      return _from;
    },
    //改变启用状态
    isChangeSwitch() {
      let newType = this.isStart;
      this.isStart = false;
      if (this._upRuleType == 2) {
        this.isStart = false;
        this.$message.warning("启用失败: 启用行为等级规则需关闭成长值等级规则");
      } else {
        let params = {
          cardId: this.$store.state.MemberSystemInfo.scoresCardId,
          upRuleType: 1,
          state: newType,
        };
        upRuleSwitch(params)
          .then((res) => {
            if (res.code == 200) {
              if (newType) {
                this.isStart = true;
                this._upRuleType = 1;
                this.$message.warning("启用成功");
              } else {
                this.isStart = false;
                this.$message.warning("修改成功");
                this._upRuleType = "";
              }
              this.$emit("changeUpRuleType", this._upRuleType);
            } else {
              this.isStart = false;
            }
          })
          .catch(() => {
            this.isStart = false;
          });
      }
    },
    // 新建升级规则：一个等级至多 3 条
    handleAdd(row) {
      const list = row.upgradeRules || [];
      if (list.length >= 3) {
        this.$message.warning("一个等级名称至多支持创建3个升级规则");
        return;
      }
      this.upgradeRuleRow = row;
      this.upgradeRuleIndex = null;
      this.upgradeRuleData = null;
      this.upgradeRulesVisible = true;
    },
    // 编辑已有规则
    handleEditRule(row, index) {
      this.upgradeRuleRow = row;
      this.upgradeRuleIndex = index;
      this.upgradeRuleData = (row.upgradeRules || [])[index] || null;
      this.upgradeRulesVisible = true;
    },
    // 删除规则
    confirmRemove() {
      const list = [...(this.removeRow.upgradeRules || [])];
      list.splice(this.removeIndex, 1);
      this.$set(this.removeRow, "upgradeRules", list);
      this.$message.success("删除成功");
      this.removeVisible = false;
    },
    // 升级规则保存：新建追加、编辑覆盖
    saveUpgradeRule({ row, rules, ruleIndex }) {
      if (!row) return;
      const list = [...(row.upgradeRules || [])];
      if (ruleIndex === null || ruleIndex === undefined) {
        list.push({ conditions: rules });
      } else {
        this.$set(list, ruleIndex, { conditions: rules });
      }
      this.$set(row, "upgradeRules", list);
      this.$message.success("保存成功");
      this.upgradeRulesVisible = false;
    },
    // 规则摘要文案
    formatRule(rule) {
      const opMap = {
        ">": "大于",
        ">=": "大于等于",
        "<": "小于",
        "<=": "小于等于",
        "=": "等于",
        "!=": "不等于",
      };
      return (rule.conditions || [])
        .map((cond) => {
          if (cond.type === "amount") {
            return `累计交易金额（实付）满${cond.value}元`;
          }
          if (cond.type === "count") {
            return `累计交易次数${cond.value}次`;
          }
          if (cond.type === "goods") {
            return `${cond.op === "1" ? "包含" : "不包含"}${
              (cond.items || []).length
            }个商品`;
          }
          if (cond.type === "point") {
            return `${this.pointLabel(cond)}${opMap[cond.op] || ""}${
              cond.value
            }`;
          }
          if (cond.type === "level") {
            const level = this.gradeName(cond.levelValue);
            return `当前等级${cond.op === "include" ? "属于" : "不属于"}会员卡${level}`;
          }
          return "";
        })
        .filter(Boolean)
        .join("，");
    },
    // 积分/等级类指标的名称：旧数据里没存 label，用 key 兜底
    pointLabel(cond) {
      const labelMap = {
        totalPoint: "累计获取积分",
        validPoint: "当前有效积分",
        consumePoint: "累计消费积分",
        currentLevel: "当前等级",
      };
      return cond.label || labelMap[cond.key] || "";
    },
    // 等级编码转名称
    gradeName(code) {
      const target = (this.form.gradeDetailList || []).find(
        (item) => item.gradeCode === code
      );
      return target ? target.gradeName : code;
    },
    // 选择商品弹窗
    selectGoods(val, index) {
      this.selectGoodsType = val;
      this.selectGoodsIndex = index;
      if (val == 1) {
        this.goodsPostForm = this.form.gradeDetailList[index].specificItems;
      } else {
        this.goodsPostForm = this.form.gradeDetailList[index].excludeItems;
      }
      this.goodsState = true;
    },
    goodsPopupBtn(event, state) {
      // state：0取消 1确定
      this.goodsState = false;
      if (state == 1) {
        if (this.selectGoodsType == 1) {
          this.form.gradeDetailList[this.selectGoodsIndex].specificItems =
            event;
        }
        if (this.selectGoodsType == 2) {
          this.form.gradeDetailList[this.selectGoodsIndex].excludeItems = event;
        }
        this.$nextTick(() => {
          this.form = JSON.parse(JSON.stringify(this.form));
        });
      }
    },
    handleMoney(event) {
      if (Number(event.target.value) == Number(0)) {
        event.target.value = "0.01";
      }
    },
    changeBehaviorLevelCalcRule(val) {
      if (val == 0) {
        const index = this.tableInfo.findIndex((item) => item.prop == "trade");
        if (index != -1) {
          this.tableInfo.splice(index, 1);
        }
      } else if (val == 2) {
        this.tableInfo.push({
          label: "交易笔数",
          prop: "trade",
          slot: "trade",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.upgrade_rules {
  height: 100%;
}
/deep/ .el-input__prefix {
  left: 3px !important;
}
// 升级规则列：多条规则纵向排列，底部是新建入口
.rule-list {
  width: 100%;
}

.rule-line {
  display: flex;
  align-items: center;
  padding: 8px 10px;
  border-bottom: 1px solid #ebeef5;
  &:last-child {
    border-bottom: none;
  }
}

.rule-text {
  flex: 1;
  margin-right: 16px;
  text-align: center;
  font-size: 13px;
  color: #606266;
  word-break: break-all;
}

.rule-opt {
  flex-shrink: 0;
  font-size: 13px;
  color: $theme-color;
  cursor: pointer;

  & + & {
    margin-left: 16px;
  }
}

.rule-add {
  padding: 8px 0;
  text-align: center;
}

.tableCont {
  width: 100%;
  text-align: center;
  padding: 0px 10px;
  .select_btn {
    color: $theme-color;
    margin-left: 12px;
    cursor: pointer;

    span {
      margin: 0 5px;
    }
  }
}

.inline_input {
  width: 100px;
  margin: 0 8px;
}
:deep(.el-table td .cell) {
  padding: 0px !important;
}
// 移除黑名单弹窗正文：居中展示提示文案
.remove-tip {
  max-width: 620px;
  margin: 0 auto;
  padding: 32px;
  text-align: center;
  font-size: 14px;
  line-height: 22px;
  color: #333333;
}
// 等级有效期：单选项与内嵌输入框同一行排列
// 注意：element-ui 的 .el-radio-group 自带 font-size: 0，这里必须显式恢复字号，
// 否则组内平铺的「后失效 / 年后的 / 失效」等文字会因字号为 0 而不可见
.valid-date {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-size: 14px;
  line-height: 22px;

  .el-radio {
    margin-right: 12px;
  }
  .valid-inline {
    display: inline-flex;
    align-items: center;
    margin-right: 20px;
  }
  .valid-num {
    width: 110px;
  }
  .valid-unit {
    width: 90px;
    margin-left: 8px;
  }
  // 前面已有文字时（如「年后的 [月] 月」），间距交给文字自身的 margin，避免叠加
  .valid-text + .valid-unit {
    margin-left: 0;
  }
  .valid-text {
    margin: 0 8px;
    color: #606266;
  }
}
</style>
